import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhyUsRoutingModule } from './why-us-routing.module';
import { WhyUsComponent } from './why-us.component';
import { ReviewComponent } from '../../shared/components/review/review.component';
import { HowToVideosComponent } from '../../shared/components/how-to-videos/how-to-videos.component';
import { SharedModule } from '../../shared.module';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    WhyUsComponent,
    ReviewComponent,
    HowToVideosComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    WhyUsRoutingModule
  ],
  exports:[
    WhyUsComponent,
    ReviewComponent,
    HowToVideosComponent
  ]
})
export class WhyUsModule { }
